export default __webpack_public_path__ + "static/media/LogoWhiteBackground.22a68465.png";